// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__X1QQd","container":"style_container__t_bmn","listing-section":"style_listing-section___QNIJ","disclaimer":"style_disclaimer__wH11B"};